export default "__VITE_ASSET__GildD3Fa__"